module.exports = (__webpack_require__(0))(5);


//////////////////
// WEBPACK FOOTER
// delegated ./src/events.js from dll-reference girder_lib
// module id = 1
// module chunks = 0